/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-04-28T10:23:25.508
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getBuildingEditInit,
	getBuildingView
} from '@api/storagemanage/Building';

import {
listBlockInit,
listBlockByAuthorizations,
deleteBlock
} from '@api/storagemanage/Block';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
		AdvanceQuery: cloneObj(RespCommonDef.AdvanceQuery)
	},
	actions: {
		getBuildingEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getBuildingEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getBuildingView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getBuildingView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
